import { UserInitializer, UserVO } from "@/types/REST-API-DOMAIN/UserVO";
import stripe from "stripe";

export interface NewSubscriptionVO {
  user: UserVO;
  newUser: UserVO;
  orgName: string;
  orgId: string | null;
  teams: number;
  minimum: boolean;
  sport: string;
  priceId: string | null;
  connectPriceId: string | null;
  dataPriceId: string | null;
  paymentMethodId: string | null;
  couponCode: string | null;
  promotion: stripe.PromotionCode | null;
  promotionId: string | null;
  usagePromotionId: string | null;
  trialDays: number;
}

export class NewSubscriptionInitializer implements NewSubscriptionVO {
  couponCode = "";
  promotion = null;
  promotionId = null;
  usagePromotionId = null;
  minimum = false;
  orgId = null;
  orgName = "";
  paymentMethodId = null;
  priceId = "";
  connectPriceId = "";
  dataPriceId = "";
  sport = "";
  teams = 1;
  user = new UserInitializer();
  newUser = new UserInitializer();
  trialDays = 30;
}
